import { createGlobalStyle} from "styled-components"
export const GlobalStyles = createGlobalStyle`
  body {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    /*background-image: url('imagens/bg-boletim.jpg');
    background-attachment: initial;
    background-position: 50% 0%;
    background-size: 50%;
    background-repeat: repeat-x;*/
    font-family: Tahoma, Helvetica, Arial, Roboto, sans-serif;
    transition: all 0.50s linear;
  }

 .imagem_bg{
    background-image: url(${({ theme }) => theme.background_image});
    background-attachment: initial;
    background-position: 50% 0%;
    background-repeat: repeat-x;
  }

  .bg{
    background-color: ${({ theme }) => theme.body};
  }

  .corpo-noticia{
    padding-top: 20px;
    padding-bottom: 20px;
    max-width: 86%;
    min-width: 66%;
    background-color: ${({ theme }) => theme.lasted_news_bg};
}

.titulo-noticia{
    background-color: ${({ theme }) => theme.lasted_news_bg};
    font-size: 16px;
    font-weight: 600;
}

.rodape-noticia{
    background-color:  ${({ theme }) => theme.lasted_news_bg};
    font-size: 13px;
}

.noticia{
    margin-bottom: 20px;
    background-color: ${({ theme }) => theme.lasted_news_bg};
}

.home-noticias{
    margin-top: 55px;
    padding-top: 15px;
    padding-left: 15px;
    padding-bottom: 15px;
    padding-right: 15px;
    background-color: ${({ theme }) => theme.noticia_home_bg};
    /*background-color: #2e5442;*/
    border-radius: 10px;
}

.lasted-news{
    padding-top: 30px;
    margin-left: 10px;
    margin-right: 10px;
    background-color: ${({ theme }) => theme.lasted_news_bg};
    border-radius: 10px;
}


#dtBasicExample tr th a {
    display: flex;
    text-decoration: none;
    color: ${({ theme }) => theme.text};
    text-align: center;
    vertical-align: middle;
  }
  
#dtBasicExample tr td a {
    display: flex;
    text-decoration: none;
    color: ${({ theme }) => theme.text};
    text-align: center;
    vertical-align: middle;
}
  
#dtBasicExample thead tr th a {
    display: flex;
    text-decoration: none;
    color: ${({ theme }) => theme.text};
    text-align: center;
    vertical-align: middle;
}
  
#dtBasicExample tr td {
    color: ${({ theme }) => theme.text};
}
  
#dtBasicExample tr th {
    color: ${({ theme }) => theme.text};
}

ul li a {
    color: ${({ theme }) =>theme.a};
    text-decoration: none;
}

ul li a:hover {
    color: ${({ theme }) =>theme.a_hover};
    text-decoration: none;
}

a.nav-link {
    color: ${({ theme }) =>theme.a};
    text-decoration: none;
}

.active{
    color: 'green';
}

a.nav-link.active:hover {
    color: ${({ theme }) =>theme.a_hover};
    text-decoration: none;
}

a.nav-link:link {
    
    color: ${({ theme }) => theme.a};
    text-decoration: none;

}

.navbar-light .navbar-nav .active > .nav-link, .navbar-light .navbar-nav .nav-link.active, .navbar-light .navbar-nav .nav-link.show, .navbar-light .navbar-nav .show > .nav-link {
    color: gray !important;
}

.navbar-light .navbar-nav .nav-link:focus, .navbar-light .navbar-nav .nav-link:hover{
    color: darkgray !important;
}

.navbar-toggler {
    filter: invert(${({ theme }) => theme.toggler_icon});
}
.selected-lang{
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    line-height: 2;
    width: 25px;
    color: ${({ theme }) => theme.a};
}
.txt_head_small{
    font-size: 0.95vw;
    font-weight: 600;
    color: ${({ theme }) => theme.a};
    text-shadow: 0 0 0.45em ${({ theme }) => theme.body};
    /*text-shadow: ${({ theme }) => theme.body} 0.1em 0.1em 0.2em;*/
}
.lang-menu ul {
    margin: 0;
    padding: 0;
    background-color: ${({ theme }) => theme.body};
    border: 1px solid gray;
    box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    display: none;
    position: absolute;
    top: 25px;
    left: -85px;
}
.aesop_logo{
    filter: invert(${({ theme }) => theme.aesop_logo});
}
.img-fiocruz{
    width: min(3vw, 45px);
    /*height: 9.5vh;*/
    aspect-ratio: 1 / 1.2;
    filter: invert(${({ theme }) => theme.aesop_logo});
}
.subtitulo {
    margin-top: 2%;
    color: ${({ theme }) => theme.text};
    text-shadow: ${({ theme }) => theme.body} 0.1em 0.1em 0.2em;
}
.cor_diferenciada{
    color: ${({ theme }) => theme.cor_diferenciada}; 
}
.sombra_diferenciada{
    color: #75ffc0;
    text-shadow: Black 0.1em 0.1em 0.2em;
}

#custom-switch:checked{
    color:#fff;
    background-color:#000;
}

a.list-group-item.list-group-item-action{
    color:#000;
    text-shadow: none;
    text-decoration: none;
}

.card_noticia{
    color: ${({ theme }) => theme.texto_noticia};
    background-color: ${({ theme }) => theme.fundo_noticia};
}

.navbar {
    background-color: rgba(${({ theme }) => theme.fundo_navbar});
}

.legend{
    color: ${({ theme }) => theme.legenda_graficos};
}

.legend table, th, td, tr {
    color: ${({ theme }) => theme.legenda_graficos};
}

.grafico{
    margin-top: 5px;
    background-color: ${({ theme }) => theme.background_grafico};
    border-radius: 15px;
    margin-bottom: 0px;    
}

.btn-close{
    background-color: ${({ theme }) => theme.text};
}

button.button_maximize.btn.btn-primary{
    background-color: ${({ theme }) => theme.background_grafico};
    background-image: url(${({ theme }) => theme.background_maximize});
    border-color: ${({ theme }) => theme.background_grafico};
    background-size: 22px 22px;
    background-position: 50% 50%;
    background-repeat: none;
    z-index:10;
}

.modal-content{
    color: ${({ theme }) => theme.text};
    background-color: ${({ theme }) => theme.background_grafico};
}

@media screen and (max-width: 995px) {
    .img-fiocruz{
        width: 30px;
        height: 45px;
        filter: invert(${({ theme }) => theme.aesop_logo});
    }

    .form-switch{
        text-align: center;
    }

    .sub-titulo{
        max-width: 0px;
        color: ${({ theme }) => theme.body};
    }
}
  `


